import { render } from "./LottieOnce.vue?vue&type=template&id=de35370c"
import script from "./LottieOnce.vue?vue&type=script&lang=js"
export * from "./LottieOnce.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__